import { IsNotEmpty, IsString } from 'class-validator';

export class ClearMctUpdateStatusDto
{
    @IsString()
    @IsNotEmpty()
    receiverId!: string;
}